import React, { useEffect, useState } from "react";
import { api, fmtCAD } from "@/lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold mb-2">Clients payés</h1>
      <p className="text-gray-500 mb-8">Clients ayant effectué au moins un paiement.</p>
      <div className="bg-white border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-500"><tr>
            <th className="p-4">Client</th><th className="p-4">Courriel</th><th className="p-4">Téléphone</th><th className="p-4">Commandes</th><th className="p-4">Total dépensé</th><th className="p-4">Dernière commande</th>
          </tr></thead>
          <tbody>
            {rows.map((c) => (
              <tr key={c.email} className="border-t border-gray-100" data-testid={`customer-row-${c.email}`}>
                <td className="p-4 font-medium">{c.name}</td>
                <td className="p-4 text-gray-500">{c.email}</td>
                <td className="p-4 text-gray-500">{c.phone || "—"}</td>
                <td className="p-4">{c.orders}</td>
                <td className="p-4 font-semibold">{fmtCAD(c.total_spent)}</td>
                <td className="p-4 text-gray-500">{c.last_order ? new Date(c.last_order).toLocaleDateString("fr-CA") : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-gray-400">Aucun client payé pour le moment.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
